module.exports = __webpack_public_path__ + "img/kids-bg.e0f8967c.jpg";